import Parser from 'html-react-parser';
import { useGetDocument } from 'pages/documents_v2/hooks/useGetDocument';
import { useGetSections } from 'pages/documents_v2/hooks/useGetSections';
import { EditAreaContext } from 'pages/documents_v2/views/edit_area/context/EditAreaContext';
import HelperFunctions from 'pages/global/HelperFunctions';
import { useContext, useMemo } from 'react';

import { TinymceEditor } from '../../TinymceEditor';

export default function TextBlock({
    block,
    baseBlock,
    index,
    readOnly = false,
    searchTerm,
    selectedSearchBlock,
    dirty,
}) {
    if (readOnly) {
        return <ReadOnlyTextBlock block={block} baseBlock={baseBlock} />;
    }

    return (
        <TinymceEditor
            block={block}
            baseBlock={baseBlock}
            index={index}
            searchTerm={searchTerm}
            selectedSearchBlock={selectedSearchBlock}
            dirty={dirty}
        />
    );
}

function ReadOnlyTextBlock({ block, baseBlock }) {
    const document = useGetDocument();
    const { hideChanges } = useContext(EditAreaContext);
    const sections = useGetSections(document?.id, true);

    const blockContent = useMemo(() => {
        if (baseBlock) {
            return hideChanges ? baseBlock.latestContentRendered : baseBlock.renderedDiffContent;
        }

        if (hideChanges === false && Object.hasOwn(block, 'renderedDiffContent')) {
            return block.renderedDiffContent;
        }

        return block.latestContent || block.baseContent || '';
    }, [block, hideChanges, baseBlock]);

    const parsedContent = useMemo(() => {
        if (sections.length === 0) {
            return blockContent;
        }

        return HelperFunctions.prepareRefs(blockContent, sections);
    }, [blockContent, sections]);

    return <div className="tiny-mce-content-body p-4">{Parser(parsedContent)}</div>;
}
